import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "textfont"
    }}>{`TextFont`}</h1>
    <p>{`Describes a font that is available to the application. Access this object in the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/photoshop/#fonts"
      }}>{`Photoshop.fonts`}</a>{` collection.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const arialMTFont = require('photoshop').app.fonts.getByName("ArialMT");
`}</code></pre>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "family"
    }}>{`family`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`family`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <p>{`The font family.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "name"
    }}>{`name`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`name`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <p>{`The name of the font.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "parent"
    }}>{`parent`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`parent`}</strong>{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/photoshop/"
      }}><em parentName="a">{`Photoshop`}</em></a></p>
    <p>{`The containing application.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "postscriptname"
    }}>{`postScriptName`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`postScriptName`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <p>{`The PostScript name of the font.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "style"
    }}>{`style`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`style`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <p>{`The font style.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "typename"
    }}>{`typename`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`typename`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <p>{`The class name of the referenced object`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      